<template>
    <div class="head">
        <div class="left-timer">{{ timer }}</div>
        <div class="head-title">
            <img src="../../assets/j-logo.png" alt="" class="j-logo" v-if="+rolelevel < 2 && !isFirst">
            {{ title }}
        </div>
        <div class="large" @click="screen">
            全屏
            <img src="../../assets/template/screen.png" alt="">
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from 'screenfull'

export default {
    name: 'headtitle.temhead8',
    props: {
        title: {
            type: String,
            default: '餐饮业招商加盟大屏'
        },
        rolelevel: {
            type: [String, Number],
            default: -1
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timer: ''
        }
    },
    mounted() {
        this.gettime()
    },
    methods: {
        gettime() {
            this.timer = moment().format('yyyy年MM月DD日  HH:mm:ss');
            setTimeout(() => {
                this.gettime()
            }, 100);
        },
        screen () {
            // 如果不允许进入全屏，发出不允许提示
            if (!screenfull.enabled) {
            // this.$message("您的浏览器不能全屏")
            return false
            }
            screenfull.toggle()
            // this.$message.success("全屏啦")
        },
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 1920px;
    height: 178px;
    background: url(@/assets/temimg16/header.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 401;
    pointer-events: none;
    .head-title {
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 44px;
        color: #FFFFFF;
        line-height: 44px;
        text-shadow: 0px 10px 10px rgba(255,255,255,0.61);
        margin-top: -80px;
        position: relative;
        letter-spacing: 6px;
    }
    .j-logo {
        position: absolute;
        width: 60px;
        height: 36px;
        left: -60px;
    }
    .left-timer {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 15px;
        font-style: italic;
        position: absolute;
        left: 64px;
        top: 64px;
        text-shadow: 0 0 10px rgba(41,81,202,.8),0 0 10px rgba(41,81,202,.8),0 0 10px rgba(41,81,202,.8);
    }
    .large {
        position: absolute;
        right: 64px;
        top: 48px;
        cursor: pointer;
        pointer-events: auto;
        font-size: 20px;
        font-style: italic;
        color: #FFFFFF;
        text-shadow: 0 0 10px rgba(41,81,202,.8),0 0 10px rgba(41,81,202,.8),0 0 10px rgba(41,81,202,.8);
        img {          
            width: 46px;
            height: 46px;
        }
    }
}
</style>